import React from "react";
import { Grid, InputAdornment, TextField } from "@mui/material";

const WineDetailTextField = ({ value, title, onChange, type, icon }) => {
  return (
    <Grid container alignItems={"center"} style={{ marginBottom: 15 }}>
      <span
        style={{ fontSize: 16, fontWeight: 600, color: "#000", width: 120 }}
      >
        {title}
      </span>
      <TextField
        variant="outlined"
        value={value}
        onChange={onChange}
        placeholder={title}
        style={textFieldStyles}
        type={type}
        InputProps={{
          style: textFieldPropsStyles,
          endAdornment: <InputAdornment position="end">{icon}</InputAdornment>,
        }}
        inputProps={{ sx: { color: "#808080" } }}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
        }}
      />
    </Grid>
  );
};

export default WineDetailTextField;

const textFieldPropsStyles = {
  fontSize: 16,
  fontWeight: 600,
};
const textFieldStyles = {
  width: 320,
  borderRadius: 8,
  background: "#F6F6F6",
  color: "#808080",
};
